module.exports = __webpack_public_path__ + "static/media/styled-components.e79a42b9.svg";